const radii = [0, 4, 8, 9999]

export default radii
